const HeaderSearch = {
  resultsEl: null,

  init() {
    this.resultsEl = $(".header-search-results");

    this.events();
  },

  events() {
    let searchThrottle;

    $(".header-search__form [name=search]").on("keyup", (e) => {
      clearTimeout(searchThrottle);
      const inputEl = $(e.currentTarget);

      if (inputEl.val().length < 3) {
        this.resultsEl.removeClass("loaded");
        this.resultsEl.removeClass("loading");
        return;
      }

      // Handle result list
      this.resultsEl.removeClass("loaded");
      this.resultsEl.addClass("loading");

      // Throttle
      searchThrottle = setTimeout(() => {
        HeaderSearch.handleSearch();
      }, 500);
    });

    $(".header-search__form").on("submit", (e) => {
      e.preventDefault();

      const formEl = $(".header-search__form");

      const searchEl = $(".header-search__form [name=search]");
      const searchUrl = formEl.attr("action") + searchEl.val();
      // console.log(formEl.attr("action"));
      window.location = searchUrl;
    });
  },

  handleSearch() {
    const formEl = $(".header-search__form");
    const formData = new FormData(formEl[0]);

    $.ajax({
      url: Sage.ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    }).then((response) => {
      let html;

      this.resultsEl.addClass("loaded");
      this.resultsEl.removeClass("loading");

      if (response.success) {
        html = HeaderSearch.renderItems(response.data);
      } else {
        html = `<p class="header-search-results__error">${Sage.i18n.no_search_results}</p>`;
      }

      this.resultsEl.children(".header-search-results__list").html(html);
    });
  },

  renderItems(items) {
    let htmlArray = items.map((item) => {
      let dateHtml = "";
      if (item.date) {
        dateHtml = `<span class="header-search-item__date">${item.date}</span>`;
      }

      let tagHtml = "";
      if (item.tag) {
        tagHtml = ` — <a href="${item.tag.link}">${item.tag.label}</a>`;
      }

      let descHtml = "";
      if (item.desc) {
        descHtml = `<p class="header-search-item__desc">${item.desc}</p>`;
      }

      return `<article class="header-search-item">
        <h2 class="header-search-item__title"><a href="${item.url}">${
        item.title
      }</a></h2>
        ${descHtml}
        <p class="header-search-item__footer">${dateHtml + tagHtml}</p>
      </article>`;
    });

    return htmlArray.join("");
  },
};
export default HeaderSearch;
